import instagram from './instagram.svg'
import github from './github.svg'
import linkedin from './linkedin.svg'
import telegram from './telegram.svg'


export const svgSocials = {
    instagram,
    github,
    linkedin,
    telegram,
}